// extracted by mini-css-extract-plugin
export default {"buttonGroup":"VotingTimerActions_buttonGroup__j5pYH"};